import { Link, useLocation } from "wouter";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarHeader,
} from "@/components/ui/sidebar";
import { Home, FolderTree, Settings, FileText, Users, ClipboardList, LayoutTemplate, ScrollText, MessageSquare } from "lucide-react";

export function AdminSidebar() {
  const [location] = useLocation();

  const navItems = [
    {
      title: "Overview",
      url: "/dashboard",
      icon: Home,
    },
    {
      title: "Users",
      url: "/users",
      icon: Users,
    },
    {
      title: "Default Content",
      url: "/categories",
      icon: FolderTree,
    },
    {
      title: "Form Builder",
      url: "/form-builder",
      icon: LayoutTemplate,
    },
    {
      title: "Government Forms",
      url: "/government-forms",
      icon: ScrollText,
    },
    {
      title: "System Settings",
      url: "/settings",
      icon: Settings,
    },
    {
      title: "Template Audit",
      url: "/template-audit",
      icon: ClipboardList,
    },
    {
      title: "Audit Log",
      url: "/audit-log",
      icon: FileText,
    },
    {
      title: "Feedback",
      url: "/feedback",
      icon: MessageSquare,
    },
  ];

  return (
    <Sidebar>
      <SidebarHeader className="p-4 border-b">
        <h2 className="text-lg font-semibold" data-testid="text-sidebar-title">
          Administration
        </h2>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>System Configuration</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {navItems.map((item) => {
                const Icon = item.icon;
                const isActive = location === item.url ||
                  (item.url === "/categories" && location.startsWith("/categories/"));
                return (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton asChild isActive={isActive}>
                      <Link href={item.url}>
                        <Icon className="w-4 h-4 text-primary" />
                        <span>{item.title}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                );
              })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
